const POLICY = `At Klingua, accessible from klinguaapp.com, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by Klingua and how we use it. If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.

Information we collect
The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information. If you contact us directly, we may receive additional information about you such as your name, email address, and the contents of your message.

How we use your information
We use the information we collect to provide, operate, and maintain the app and website; to improve and personalize your experience; to understand how you use the app; to develop new features; and to communicate with you.

Log files
Klingua follows a standard procedure of using log files. These files log visitors when they visit websites. The information collected by log files includes IP addresses, browser type, Internet Service Provider (ISP), date and time stamp, and referring/exit pages. These are not linked to any personally identifiable information and are used for analyzing trends and administering the site.

Children's information
Klingua does not knowingly collect any personally identifiable information from children under the age of 13. If you think that your child provided this kind of information, please contact us and we will promptly remove it from our records.

Your rights (GDPR & CCPA)
You have the right to access, correct, erase, restrict, or object to the processing of your personal data, and the right to data portability. To exercise any of these rights, please contact us.

Changes to this Privacy Policy
We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.`;

export default function Privacy() {
  return (
    <section className="section privacy" id="privacy">
      <div className="container">
        <details>
          <summary>
            Privacy Policy
            <span className="chev" aria-hidden="true">▾</span>
          </summary>
          <div className="body">{POLICY}</div>
        </details>
      </div>
    </section>
  );
}
